var _getWidgetBindings;

_getWidgetBindings = function(element, valueAccessor, allBindingsAccessor) {
  var allBindings, disabled, enabled, myBinding, value, widgetName, widgetOptions;
  value = valueAccessor();
  myBinding = ko.unwrap(value);
  allBindings = allBindingsAccessor();
  if (typeof myBinding === 'string') {
    myBinding = {
      'name': myBinding
    };
  }
  widgetName = myBinding.name;
  widgetOptions = myBinding.options;
  disabled = myBinding.disabled;
  enabled = myBinding.enabled;
  if (typeof $.fn[widgetName] !== 'function') {
    throw new Error('widget binding doesn\'t recognize \'' + widgetName + '\' as jQuery UI widget');
  }
  if (allBindings.options && !widgetOptions && element.tagName !== 'SELECT') {
    throw new Error('widget binding options should be specified like this:\ndata-bind=\'widget: {name:"' + widgetName + '", options:{...} }\'');
  }
  return {
    widgetName: widgetName,
    widgetOptions: widgetOptions,
    disabled: disabled,
    enabled: enabled
  };
};

ko.bindingHandlers.widget = {
  update: function(element, valueAccessor, allBindingsAccessor) {
    var subscribeToDisabledIfSet, subscribeToEnabledIfSet, updateDisabled, widgetBindings;
    widgetBindings = _getWidgetBindings(element, valueAccessor, allBindingsAccessor);
    updateDisabled = function(disabled) {
      var methodName;
      methodName = disabled ? 'disable' : 'enable';
      $(element)[widgetBindings.widgetName](methodName);
    };
    subscribeToDisabledIfSet = function(disabled) {
      if (disabled === void 0 || disabled === null) {
        return;
      }
      if (ko.isObservable(disabled)) {
        disabled.subscribe(function(newValue) {
          updateDisabled(newValue);
        });
      }
      updateDisabled(ko.unwrap(disabled));
    };
    subscribeToEnabledIfSet = function(enabled) {
      if (enabled === void 0 || enabled === null) {
        return;
      }
      if (ko.isObservable(enabled)) {
        enabled.subscribe(function(newValue) {
          updateDisabled(!newValue);
        });
      }
      updateDisabled(!ko.unwrap(enabled));
    };
    $(element)[widgetBindings.widgetName](widgetBindings.widgetOptions);
    subscribeToDisabledIfSet(widgetBindings.disabled);
    subscribeToEnabledIfSet(widgetBindings.enabled);
  }
};
